import React from 'react';

const CoverPlaceholderSection = () => {
  return (
    <div className={'grid aspect-video flex-1 place-items-center bg-stone-500 animate-pulse'} />
  );
};

export default CoverPlaceholderSection;
